import Cookies from "js-cookie"
import { BASE_URL } from "../constants"
import FetchUtils from "../utils/fetch"
import { UserContextEntity } from "../entities/UserEntity"

class AuthService {
    static async login(username: string, password: string): Promise<UserContextEntity> {
        if (username === '' || password === '') { throw Error("Username and password are required!") }
        try {
            const resp = await fetch(`${BASE_URL}/api/v1/auth`, {
                method: "POST",
                body: JSON.stringify({ username, password }),
                headers: { "Content-Type": "application/json" }
            })
            const body = { ...(await resp.json()), status: resp.status }

            if (body.status !== 200) {
                Cookies.remove("access_token")
                throw new Error(body.message)
            } else {
                if (body.data.access_token == null) {
                    throw new Error(body.message)
                }

                console.log("Login Success")
                Cookies.set("access_token", body.data.access_token)
                return { username: body.data.username, rolename: body.data.grup }
            }
        } catch (error) {
            Cookies.remove("access_token")
            throw error
        }
    }

    static async refreshLogin(): Promise<UserContextEntity> {
        if (Cookies.get("access_token") == null) { throw new Error("token not found") }
        try {
            const resp = await fetch(`${BASE_URL}/api/v1/auth/refresh`, {
                method: "POST",
                headers: {"Authorization": `Bearer ${Cookies.get("access_token")}`}
            })
            if (resp.status !== 200) { throw new Error("TOKEN EXPIRED") }
            const body = await resp.json()

            console.log("Token Refreshed")
            Cookies.set("access_token", body.data.access_token)
            return { username: body.data.username, rolename: body.data.grup }
        } catch (error) {
            Cookies.remove("access_token")
            throw error
        }
    }

    static async changePass(password: string, newpassword: string) {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/auth/change_pass`, {
            method: "POST",
            body: JSON.stringify({ password: password, newpassword: newpassword }),
            headers: { "Content-Type": "application/json" }
        })
        if (resp.status !== 200) { throw Error(resp.message) }

        return resp
    }

    static async logout() {
        Cookies.remove("access_token")
    }
}

export { AuthService }